import React, { useCallback } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from 'js/components';
import { useEditorContext } from 'js/ydoc/docs/capabilities-assessment/EditorContext';
import { shouldRenderPageHeader } from 'js/engines/CapabilitiesAssessment/utils';

import styles from '../CapabilitiesAssessmentEditor.module.scss';

/**
 * Whether this page shows its title and description at the top. The progress
 * slider names the page either way.
 */
function PageHeaderToggle({ page }) {
  const { updatePageFields } = useEditorContext();
  const shown = shouldRenderPageHeader(page);
  const id = `page-header-toggle-${page.guid}`;
  const label = shown
    ? 'Title and description are shown on the page'
    : 'Title and description are hidden on the page';

  const handleClick = useCallback(() => {
    updatePageFields(page.guid, { renderHeader: !shown });
  }, [page.guid, shown, updatePageFields]);

  return (
    <>
      <button
        type="button"
        id={id}
        className={styles['page-header-toggle']}
        onClick={handleClick}
        aria-label={label}
        aria-pressed={shown}
      >
        <Icon icon={shown ? faEye : faEyeSlash} className="icon" fixedWidth />
      </button>
      <UncontrolledTooltip placement="top" target={id}>
        {label}
      </UncontrolledTooltip>
    </>
  );
}

export default PageHeaderToggle;
